import { Extension } from "@tiptap/core";
import Suggestion from "@tiptap/suggestion";
import { isEmptyLineSlashAllowed, shouldResetSlashDismissed } from "./slashCommandItems";
import { createSlashDismissSyncPlugin } from "./slashDismissSync";

export { createSlashDismissSyncPlugin } from "./slashDismissSync";

function resolveIsEmptyLineSlashAllowed(context) {
  if (typeof window !== "undefined" && typeof window.__exiqIsEmptyLineSlashAllowed === "function") {
    return window.__exiqIsEmptyLineSlashAllowed(context);
  }
  return isEmptyLineSlashAllowed(context);
}

function resolveCreateSlashDismissSyncPlugin() {
  if (typeof window !== "undefined" && typeof window.__exiqCreateSlashDismissSyncPlugin === "function") {
    return window.__exiqCreateSlashDismissSyncPlugin();
  }
  return createSlashDismissSyncPlugin();
}

function resolveShouldResetSlashDismissed(context) {
  if (typeof window !== "undefined" && typeof window.__exiqShouldResetSlashDismissed === "function") {
    return window.__exiqShouldResetSlashDismissed(context);
  }
  return shouldResetSlashDismissed(context);
}

export {
  createSuggestionItems,
  filterSlashItems,
  isEmptyLineSlashAllowed,
  renderSlashMenuItems,
  markBlockDismissed,
  clearBlockDismissed,
  clearAllDismissed,
  dismissSlashMenuUI,
  destroyAllSlashMenus,
  syncSlashDismissState,
  shouldResetSlashDismissed,
  dismissSlashMenuForBackspace,
  isSlashMenuVisible,
} from "./slashCommandItems";

export const SlashCommand = Extension.create({
  name: "slashCommand",

  addOptions() {
    return {
      suggestion: {
        char: "/",
        allow: resolveIsEmptyLineSlashAllowed,
        command: ({ editor, range, props }) => {
          props.command({ editor, range });
        },
      },
    };
  },

  addProseMirrorPlugins() {
    return [
      resolveCreateSlashDismissSyncPlugin(),
      Suggestion({
        editor: this.editor,
        decorationClass: "slash-command-suggestion",
        shouldResetDismissed: resolveShouldResetSlashDismissed,
        ...this.options.suggestion,
      }),
    ];
  },
});
